import React, { useCallback, useEffect, useState } from 'react'
import B2BLayout from '../../layouts/b2b'
import { ReportIframe } from './components/report'
import { Result, Skeleton } from 'antd'
import fetchAPI, { IHttpError } from '../../../lib/utils/fetch-api'
import { ResultStatusType } from 'antd/lib/result'

interface IError {
  code?: ResultStatusType,
  message?: string,
}

export const PowerbiReport = () => {
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<IError | null>(null)

  const breadcrumbs = [
    {
      href: '/admin',
      title: 'Админка',
    },
    {
      href: '/powerbi-report',
      title: 'Отчёт Power BI',
    }]

  const checkAccess = useCallback(async () => {
    setLoading(true)
    await fetchAPI(`/api/user_permissions`)
      .then(user_permissions => {
        const hasPermission = user_permissions.includes('access_powerbi')
        if (!hasPermission) {
          setError({
            message: 'У вас нет доступа к этому разделу.',
            code: 403,
          })
        } else {
          setError(null)
        }
      })
      .catch(e => {
        setError({
          message: (e as IHttpError)?.message || 'Неизвестная ошибка',
          code: ((e as IHttpError)?.statusCode || 'error') as ResultStatusType
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  useEffect(() => {
    checkAccess()
  }, [])
  
  return (
    <B2BLayout breadcrumbs={breadcrumbs}>
      {loading && <Skeleton active/>}
      {!loading && error && <Result status={error.code} title='Ошибка' subTitle={error.message} />}
      {!loading && !error && <ReportIframe />}
    </B2BLayout>
  )
}
